<template>
  <FormBuilder :formData="formData" :formValue="formValue"></FormBuilder>
</template>

<script>
import FormBuilder from "../../FormBuilder.vue"

export default {
  components: {
    FormBuilder
  },
  props: {
    formValue: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      formData: [
        {
          title: "Planned lot/batch",
          description: "Setup the planned or completed lots/batches for each DUN in each treatment group",
          anchor: "5.1",
          forms: [{
            type: "sectionarray",
            label: "Lots/Batches",
            value: "production.plannedBatchs",
            buttonText: "New planned lot/batch",
            grid: "grid-50w",
            forms: [
              {
                type: "guid",
                label: "batchGuid",
                value: "batchGuid",
                required: true
              },
                {
              type: "text",
              label: "Name",
              value: "name",
              required: true
            }, {
              type: "calendar",
              label: "Production Start date",
              required: true,
              value: "productionDate"
            }, {
              type: "calendar",
              label: "Available date",
              value: "availableDate",
              required: true
            }, {
              type: "calendar",
              label: "Expiry date",
              value: "expiry",
              required: true
            }, {
              type: "text",
              label: "Do-not-ship duration",
              value: "doNotShipDuration",
              inline: "Days",
              required: true
            }, {
              type: "number",
              label: "Lot/Batch size",
              value: "size",
              inline: "Total DUN",
              required: true
            }
              ,
              {

                type: "select",
                label: "Associate depot / supply chain",
                value: "supplyChainId",
                extraClass: "grid-full",
                preValues: {
                  field: "supplyChainDepots",
                  name: "name",
                  value: "supplyChainId"
                },
                required: true

              },
              {

                type: "select",
                label: "Select dispensing unit",
                value: "dispensingUnitId",
                required: true,
                extraClass: "grid-full",
                preValues: {
                  field: "dispensingUnits",
                  value: "id",
                  name: "name"
                }

              }
              ,
              {

                type: "typeahead-countries",
                label: "Released to",
                value: "restrictToCountries",
                multiple: true,
                extraClass: "grid-full",
                placeholder: "Countries - Leave empty to select all.",
                preValues: {
                  field: "restrictToCountries"
                }
              }

            ]
          }]
        }, {
          title: "Lots/Batches Templates",
          description: "Setup a lots/batch template for each DUN",
          anchor: "5.2",
          forms: [{
            type: "sectionarray",
            label: "Lots/Batch",
            value: "production.batchTemplates",
            buttonText: "New lot/batch template",
            grid: "grid-50w",
            forms: [{
              type: "text",
              label: "Name",
              value: "name",
              required: true
            }, {
              type: "text",
              label: "Projected expiry",
              value: "stability",
              helper: "Add the average number of days of projected expiry that the DUN has left when secondary packaging and labelling begins",
              inline: "Days",
              required: true
            }, {
              type: "text",
              label: "Do-not-ship duration",
              value: "doNotShipDuration",
              helper: "Minimum expiry time that needs to be left to be able to arrive on sites.",
              inline: "{format}",
              required: true
            }
              , {
                type: "void"
              }
              , {
                type: "number",
                label: "DUN Production leadtime",
                helper: "Time in days that it takes to complete a production.",
                value: "dunLeadTime",
                inline: "{format}",
                required: true
              }
              , {
                type: "number",
                label: "Min time/interval between production",
                value: "minProductionInterval",
                minValue: "",
                inline: "{format}",
                helper: "Leave empty to use  production leadtime as minimum number of days between production",
                placeholder: "Leave empty to use production leadtime"
              }
              , 
              {
                type: "number",
                label: "Min Lot/Batch size",
                value: "minSize",
                inline: "Total DUN",
                minValue: "",
                required: false,
                placeholder: "Leave empty to let the system decide"
              }
              , 
              {
                type: "number",
                label: "Max Lot/Batch size",
                value: "size",
                inline: "Total DUN",
                minValue: "",
                required: false,
                placeholder: "Leave empty to let the system decide"
              }
              ,
              {

                type: "select",
                label: "Associate depot / supply chain",
                value: "supplyChainId",
                extraClass: "grid-full",
                preValues: {
                  field: "supplyChainDepots",
                  name: "name",
                  value: "supplyChainId"
                },
                required: true

              },
              {

                type: "select",
                label: "Select dispensing unit",
                value: "dispensingUnitId",
                extraClass: "grid-full",
                preValues: {
                  field: "dispensingUnits",
                  value: "id",
                  name: "name"
                },
                required: true

              }

            ]
          }]
        }]
    }
  },
  mounted: function ()
  {
  },
  methods: {
    restrictedCountryCallBack: function (data, global) {
     /* debugger;
      var test = this.$store.state.editor.version;
        var siteCountries = data.sites.select(x=>x.address.country);
        var depotCountries = data.depots.select(x=>x.address.country);
      
        var allCountries = siteCountries.concat(depotCountries); 
        var options = [];
        allCountries.forEach(x => options.push(new {id:x, label:x}));
        
        return options;
        */
    }
  }
}
</script>
